/**
 * AuthFrame — the centered card the sign-in and callback pages share: the
 * product mark above whatever state the page is in.
 */
import type { ReactNode } from 'react';

export function AuthFrame({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--surface-card)',
        padding: 16,
      }}
    >
      <div
        style={{ width: '100%', maxWidth: 448, display: 'flex', flexDirection: 'column', gap: 22 }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
          <div
            aria-hidden="true"
            style={{
              display: 'grid',
              width: 32,
              height: 32,
              placeItems: 'center',
              borderRadius: 'var(--radius-chip)',
              background: 'var(--surface-inverse)',
              fontSize: 'var(--text-title)',
              fontWeight: 'var(--weight-medium)',
              letterSpacing: '-0.025em',
              color: 'var(--text-inverse)',
            }}
          >
            O
          </div>
          <h1
            style={{
              fontSize: 'var(--text-page-sm)',
              fontWeight: 'var(--weight-semibold)',
              letterSpacing: '-0.025em',
            }}
          >
            Optum
            <span
              style={{
                marginLeft: 7,
                fontSize: 'var(--text-meta-lg)',
                fontWeight: 'var(--weight-medium)',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                color: 'var(--text-muted)',
              }}
            >
              admin
            </span>
          </h1>
        </div>
        {children}
      </div>
    </div>
  );
}
